import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import { ALLOWED_LOCALES, I18N_COOKIE_KEY } from './config/constants/i18n';

export const getLanguage = () => {
  if (typeof window === 'undefined') return 'en';

  const localeCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${I18N_COOKIE_KEY}=`))
    ?.split('=')[1];

  const locale = localeCookie || window.navigator.language;

  if (ALLOWED_LOCALES.find(allowedLocale => allowedLocale.toLowerCase() === locale.toLowerCase())) {
    return locale;
  }

  const splitLocale = locale?.split('-')?.[0];

  if (splitLocale && ALLOWED_LOCALES.find(allowedLocale => allowedLocale.toLowerCase() === splitLocale.toLowerCase())) {
    return splitLocale;
  }

  return 'en';
};

i18n
  .use(ICU)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    ns: ['common'],
    load: 'currentOnly',
    defaultNS: 'common',
    lng: getLanguage(),
    fallbackLng: getLanguage(),
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
